<div class="list-wrapper">
  <!-- Mail list header -->
  <div class="header">
    <!-- Header left -->
    <div class="left">
      <!-- Sidebar toggle button -->
      <button class="sidebar-toggle" mat-icon-button (click)="projectsListComponent.drawer.toggle()">
        <mat-icon [svgIcon]="'menu'"></mat-icon>
      </button>

      <!-- Category name -->
      <div class="category">{{ pipeline.name }}</div>
    </div>

    <div class="main-actions">
      <project-list-header [pipeline]="pipeline"></project-list-header>

      <div class="projects-list-filter">
        <list-filter
          (filterSearchInput)="searchInput($event)"
          (projectFilters)="filterProjects($event)"
          [queryFilters]="queryFilters"
          [savedFilter]="savedFilter"
          [hideSaveButton]="hideSaveButton()"
          [hideFilterName]="isPipelineDynamic()"
          [allowRelatedObjectFields]="hasNestedFiltersOn"
        ></list-filter>
      </div>

      <!-- Add contact button -->
      <input style="display: none" type="file" (change)="onProjectFileChanged($event)" #projectFileInput />

      <button
        [appAuthorize]="canAddDeal"
        denyAction="disable"
        class="add-contact ml-2"
        [matMenuTriggerFor]="addProjectMenu"
        mat-flat-button
        [color]="'primary'"
      >
        <ng-container *ngIf="!uploadingFile">
          <mat-icon [svgIcon]="'keyboard_arrow_down'"></mat-icon>
          Add
        </ng-container>
        <mat-progress-spinner *ngIf="uploadingFile" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
      </button>
      <mat-menu #addProjectMenu="matMenu">
        <button id="create-project" mat-menu-item (click)="openCustomDrawer()">
          <span class="ml-2"> <mat-icon svgIcon="add"></mat-icon> Enter Details </span>
        </button>
        <button mat-menu-item (click)="createProjectByUrl()">
          <span class="ml-2"><mat-icon [svgIcon]="'add'"></mat-icon> By Url</span>
        </button>
        <button mat-menu-item (click)="projectFileInput.click()">
          <span class="ml-2"><mat-icon [svgIcon]="'publish'"></mat-icon> Upload OM</span>
        </button>
        <button mat-menu-item (click)="navigateToProjectsAddMap()">
          <span class="ml-2"> <mat-icon [svgIcon]="'language'"></mat-icon> Select On Map </span>
        </button>
      </mat-menu>

      <button appAuthorize="PIPELINE_MANAGE" class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
        <mat-icon svgIcon="more_vert"></mat-icon>
      </button>
      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="editLayout()">
          <mat-icon svgIcon="file_copy"></mat-icon>
          Edit Layout
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="projects-list">
    <div class="table-wrapper">
      <div class="inline-table-wrapper">
        @if (isLoading) {
          <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        }
        <table class="table-auto" [ngClass]="{ loading: isLoading }">
          <tbody>
            <ng-container *ngFor="let group of groupedProjects; trackBy: trackByFn">
              <ng-container *ngIf="group.vals && group.vals.length > 0">
                <tr class="group">
                  <td
                    data-cy="project-grid-group-label"
                    colspan="16"
                    style="background-color: #29333f; font-weight: bold; color: #fff"
                    class="p-2"
                  >
                    {{ group.label }}
                  </td>
                </tr>
                <tr *ngFor="let project of group.vals">
                  <td class="flex border-b-2">
                    <div class="flex flex-row flex-auto">
                      <div class="flex flex-row mr-4">
                        <span class="left">
                          <button class="more-menu" [matMenuTriggerFor]="moreMenu">
                            <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                          </button>
                          <mat-menu #moreMenu="matMenu">
                            <button
                              mat-menu-item
                              (click)="moveDeal(project)"
                              [appAuthorize]="[NewPermission.DEALS_EDIT, project.permissions?.is_deletable]"
                              denyAction="disable"
                            >
                              <mat-icon [svgIcon]="'swap_horiz'"></mat-icon>
                              <span>Move</span>
                            </button>
                            <button
                              [appAuthorize]="canDeleteDeal(project)"
                              denyAction="disable"
                              mat-menu-item
                              (click)="deleteProject(project)"
                            >
                              <mat-icon [svgIcon]="'delete'"></mat-icon>
                              <span>Delete</span>
                            </button>
                          </mat-menu>
                        </span>
                        <a [routerLink]="['../' + project.id + '/details/overview']"
                          ><img
                            src="{{ project.featured_image_url }}"
                            class="mr-1"
                            style="min-width: 90px; max-width: 125px"
                            onerror="this.onerror=null;this.src='https://termsheet-cdn.s3.amazonaws.com/placeholder.jpg';"
                            alt="project.title"
                        /></a>
                      </div>
                      <div class="flex flex-row flex-auto justify-between mt-2">
                        <div class="flex flex-col mr-5 flex-auto">
                          <a [routerLink]="['../' + project.id + '/details/overview']" class="font-bold">{{
                            project.title
                          }}</a>
                          <div class="flex flex-row">
                            <div
                              style="min-width: 400px; max-width: 400px"
                              *ngFor="let column of gridFields; index as gridFieldsIndex"
                            >
                              <ng-container *ngFor="let column of gridFields[gridFieldsIndex]; index as i">
                                <ng-container *ngIf="lookupField(column) as fieldDef">
                                  <ng-container *ngIf="isLinkedFieldColumn(fieldDef); else defaultField">
                                    <div class="flex flex-row">
                                      <div class="font-semibold mr-1 text-md">{{ fieldDef.label }}:</div>
                                      <div class="text-md">
                                        <linkable-related-field-cell
                                          [type]="fieldDef?.related_to_type"
                                          [value]="getLinkedFieldValue(project, fieldDef.name)"
                                        ></linkable-related-field-cell>
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #defaultField>
                                    <app-inline-field
                                      [ngClass]="{ invisible: fieldDef.name === emptyFieldName }"
                                      [fieldDef]="fieldDef"
                                      [model]="project"
                                      [data]="data"
                                    ></app-inline-field>
                                  </ng-template>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                        <div class="mr-4">
                          <mat-form-field class="flex-auto gt-xs:pr-3">
                            <mat-select
                              [placeholder]="'Status'"
                              [ngModel]="+project.project_stage_id"
                              [appAuthorize]="[NewPermission.DEALS_EDIT, project.permissions?.is_editable]"
                              denyAction="disable"
                              (selectionChange)="onUpdate($event, project)"
                            >
                              <mat-option
                                *ngFor="let projectStage of projectStages"
                                [value]="projectStage.id"
                                [disabled]="disableDropdownOptions(projectStage, project)"
                                [matTooltip]="
                                  disableDropdownOptions(projectStage, project) ? 'Option disabled for this deal' : null
                                "
                              >
                                {{ projectStage.name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
      <mat-paginator
        [ngClass]="{ loading: isLoading }"
        [length]="pagination.length"
        [pageIndex]="pagination.page"
        [pageSize]="pagination.size"
        [pageSizeOptions]="[5, 10, 25, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator>

      <ng-template #noProjects>
        <div class="no-products">There are no deals!</div>
      </ng-template>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
